<template>
  <div>
    <div>
      <img ref="image" :src="image_source"/>
    </div>
    <div>
      <input ref="x" name="x" type="hidden"/>
      <input ref="y" name="y" type="hidden"/>
      <input ref="h" name="h" type="hidden"/>
      <input ref="w" name="w" type="hidden"/>
    </div>
  </div>
</template>

<script>
    import Cropper from 'cropperjs';
    export default {
        props: ['image_source'],
        mounted() {
            const image = this.$refs.image;
            const component = this;
            const cropper = new Cropper(image, {
                aspectRatio: 16 / 9,
                crop(event) {
                    component.$refs.x.setAttribute('value', event.detail.x);
                    component.$refs.y.setAttribute('value', event.detail.y);
                    component.$refs.w.setAttribute('value', event.detail.width);
                    component.$refs.h.setAttribute('value', event.detail.height);

                },
            });
        }
    }
</script>
